import React from 'react';

const WhyUs = () => {
    return (
        <section className="section section--alt" id="why-us">
            <div className="container whyus">
                <div className="whyus__text">
                    <h2 className="section__title">Why Choose The M&amp;M Services</h2>
                    <p>
                        The M&amp;M Services is locally owned and operated. We’re proud
                        to serve Guelph, Kitchener, Waterloo, and Cambridge with reliable, detail-oriented
                        cleaning using eco-friendly products.
                    </p>
                    <p>
                        Whether it’s your family home or your business, we treat every space with care and
                        respect.
                    </p>
                </div>
                <div className="whyus__highlights">
                    <div className="pill">
                        <span className="pill__icon">✓</span>
                        Trusted by local homeowners &amp; businesses
                    </div>
                    <div className="pill">
                        <span className="pill__icon">✓</span>
                        Eco-friendly cleaning products
                    </div>
                    <div className="pill">
                        <span className="pill__icon">✓</span>
                        Free quotes, no surprise fees
                    </div>
                    <div className="pill">
                        <span className="pill__icon">✓</span>
                        Flexible scheduling &amp; recurring options
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyUs;
